/**
 * Share-code minting — shared by quiz-sharing and deck-sharing.
 *
 * Allocates an opaque base58-ish token client-side; the owner's UserDo
 * mirrors the resulting `shareCode` field into the relevant share KV
 * namespace automatically once the sync push lands.
 *
 * Keep this in sync with the `SHARE_CODE_RE` regex on the recipient-read
 * routes (`flashka-web/server/routes/share-quiz.ts`,
 * `flashka-web/server/routes/share-deck.ts`).
 */

const ALPHABET = 'ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
export const SHARE_CODE_LENGTH = 11;

export function mintShareCode(): string {
  const bytes = new Uint8Array(SHARE_CODE_LENGTH);
  // `crypto` is provided by every supported runtime (Node 19+, modern
  // browsers, React Native Hermes via `expo-crypto` polyfill, Cloudflare
  // Workers). No fallback path — fail loudly if the environment is
  // missing it.
  globalThis.crypto.getRandomValues(bytes);
  let out = '';
  for (let i = 0; i < SHARE_CODE_LENGTH; i++) {
    out += ALPHABET[bytes[i] % ALPHABET.length];
  }
  return out;
}
